import { PlayIcon } from '@heroicons/react/24/solid';

export const StartingThumbnailVideo = ({ isSelected, setSelectedSource }) => {
  return (
    <button
      className="thumbnail-button"
      onClick={(event) => {
        return setSelectedSource(event);
      }}
    >
      <div className="thumbnail-stream aspect-video">
        <div className="thumbnail-stream-dot" />
        <div className="fake-video-container w-60 p-0">
          <div className="loader-container w-full gap-2">
            <div className="loader-small"></div>
            <div className="loader-message text-sm">The stream will start soon...</div>
          </div>
        </div>
        {isSelected && (
          <div className="selected-source">
            <PlayIcon className="selected-source-play-icon" />
            <div>Now Playing</div>
          </div>
        )}
      </div>
    </button>
  );
};
